import React, { forwardRef } from "react";
import styled from "styled-components";
import { colors, easing, layout, media, radii, shadows } from "../../../theme";

const CategoriesBar = forwardRef(
  ({ categories, selected, allLabel, onSelect }, ref) => {
    return (
      <Bar ref={ref}>
        <Track>
          <Chip
            type="button"
            $active={!selected}
            aria-pressed={!selected}
            onClick={() => onSelect(null)}
          >
            {allLabel}
          </Chip>
          {categories.map((category) => {
            const isActive = category.value === selected;
            return (
              <Chip
                key={category.value}
                type="button"
                $active={isActive}
                aria-pressed={isActive}
                onClick={() => onSelect(category.value)}
              >
                {category.title}
              </Chip>
            );
          })}
        </Track>
      </Bar>
    );
  }
);

const Bar = styled.div`
  position: sticky;
  top: ${layout.navHeightCompact};
  z-index: 20;
  border-bottom: 1px solid rgba(210, 180, 140, 0.35);
  background-color: rgba(255, 255, 234, 0.88);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
`;

const Track = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: 0.9rem ${layout.gutter};

  ${media.mobile} {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const Chip = styled.button`
  flex-shrink: 0;
  padding: 0.55rem 1.1rem;
  border: 1px solid
    ${({ $active }) => ($active ? colors.secondary : "rgba(210, 180, 140, 0.8)")};
  border-radius: ${radii.pill};
  background-color: ${({ $active }) =>
    $active ? colors.secondary : colors.backgroundSecondary};
  color: ${({ $active }) => ($active ? colors.primary : colors.textMain)};
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: ${({ $active }) => ($active ? shadows.sm : "none")};
  transition: background-color 0.3s ease, color 0.3s ease,
    border-color 0.3s ease, transform 0.4s ${easing.out};

  &:hover {
    border-color: ${colors.secondary};
    transform: translateY(-1px);
  }
`;

export default CategoriesBar;
